// extracted by mini-css-extract-plugin
export var standaloneTable = "_gn-0";
export var withExtraHeader = "_gn-1";